import { useLocation } from 'react-router';
import { useDispatch, useSelector } from '../redux/store';
import { setActiveTab } from '../redux/slices/game';
import { useLangNavigate } from './useLangNavigate';

const useGameNav = () => {
  const { activeTab } = useSelector((x) => x.game);

  const location = useLocation();

  const navigate = useLangNavigate();

  const dispatch = useDispatch();

  const changeTab = (slug) => {
    dispatch(setActiveTab(slug));
    if (location.pathname === '/') navigate('/');
  };

  return {
    activeTab,
    changeTab,
  };
};

export default useGameNav;
